import React, { useEffect, useState } from 'react';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import useCurrentClientProfileContext from '../ui/useCurrentClientProfileContext';
import ContinueButton from '../ui/ContinueButton';
import useClientsEventBookingFormMutation from './hooks/useClientsEventBookingFormMutation';
import WelcomeFlagShip from '../ui/WelcomeFlagship';
import AppointmentTypeSelect from '../../../../../base/ui/AppointmentTypeSelect';
import DressTypeSelect from '../../../../../base/ui/DressTypeSelect';
import { bookingAppointmentTypes } from '../../../../../base/utils/appointmentTypes';
import isObjEmpty from '../../../../../base/utils/isObjEmpty';
import BookingStep1 from '../../images/booking-img-step-1.jpg';

function AppointmentForm() {
  const { SelectMui, Grid, InputMui, InputMask, TextField, InputLabel, Checkbox } = useUiContext();
  const { currentClient } = useCurrentClientProfileContext();
  const { id: currentClientId, email: ccEmail, firstName: ccFirstName, lastName: ccLastName, bestPhoneNumber: { id: phoneId, phoneNo: ccPhone } = {}, address: { id: addressId, zipCode: ccZip } = {}, allowSms } = currentClient;
  const existingClient = !!currentClientId;
  const phoneNumberTypes = ['Mobile', 'Home', 'Work'];
  const preferredLangs = ['English', 'French', 'German', 'Greek', 'Mandarin', 'Russian', 'Spanish', 'Ukrainian'];

  const { useRouter } = useAppContext();
  const router = useRouter();
  const { match: { url } } = router;

  const onboardingProceed = !url.includes('/new_appointment');
  const newAppointmentProceed = url.includes('/new_appointment');
  const canProceed = newAppointmentProceed;

  const getDisabledStatusForField = (textfield) => existingClient && textfield !== '';

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [phoneTypeS, setPhoneType] = useState('Mobile');
  const [zipCode, setZipCode] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(null);
  const [isPhoneNoValid, setIsPhoneNoValid] = useState(null);
  const [conciergeOption, setConciergeOption] = useState('SoHo Flagship');
  const [dressType, setDressType] = useState('');
  const [processData, setProcessData] = useState(false);
  const [preferredLang, setPreferredLang] = useState('English');
  const [allowSmsCheckbox, setAllowSmsCheckbox] = useState(allowSms || true);
  const [allowEmailCheckbox, setAllowEmailCheckbox] = useState(allowSms || true);

  const handleSelect = (name) => ({ target }) => {
    const { value } = target;
    switch (name) {
      case 'dressType':
        setDressType(value);
        break;
      case 'conciergeOption':
        setConciergeOption(value);
        break;
      default:
        return null;
    }
    return false;
  };

  const { mutate } = useClientsEventBookingFormMutation();

  const validateEmailFormat = (e) => {
    const regEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const valid = regEmail.test(e);
    setIsEmailValid(valid);
    return valid;
  };

  useEffect(() => {
    if (email !== '') {
      validateEmailFormat(email);
    }
  }, [email]);

  const mySetEmail = (e) => {
    setEmail((e.target.value).trim());
    validateEmailFormat(e.target.value);
  };

  const validatePhoneNo = (p) => {
    const regPhoneNo = /_/;
    const valid = !regPhoneNo.test(p) && p !== '';
    setIsPhoneNoValid(valid);
    return valid;
  };

  useEffect(() => {
    if (phoneNo) {
      validatePhoneNo(phoneNo);
    }
  }, [phoneNo]);

  const showHelperText = (validState, copy) => {
    if (validState == null) {
      return false;
    }

    if (!validState) {
      return copy;
    }

    return null;
  };

  useEffect(() => {
    if (!isObjEmpty(currentClient)) {
      setFirstName(ccFirstName);
      setLastName(ccLastName);
      setEmail(ccEmail);
      setPhoneNo(ccPhone);
      setZipCode(ccZip);
    }
  }, [currentClient]);

  const getApptBasedOnDress = () => {
    switch (dressType) {
      case 'Bridal':
        return 'Bridal First Appointment';
        break;
      case 'Bridesmaids':
        return 'Bridesmaids First Appointment';
        break;
      case 'Little White Dress':
        return 'Little White Dress First Appointment';
        break;
      case 'Evening / Mother of the Bride':
        return 'Evening First Appointment';
        break;
      case 'Accessories':
        return 'Accessories First Appointment';
        break;
      default:
        return '';
    }
  };

  const handleContinue = () => {
    setProcessData(true);
    if (validateEmailFormat(email) && validatePhoneNo(phoneNo)) {
      const input = {
        clientAttributes: {
          id: currentClientId,
          firstName,
          lastName,
          email,
          bestPhoneNumberAttributes: { id: phoneId, phoneNo, isBest: true, phoneType: phoneTypeS },
          addressAttributes: { id: addressId, zipCode },
          preferredLang,
          allowSms: allowSmsCheckbox,
          allowEmail: allowEmailCheckbox,
        },
        appointmentsAttributes: [{
          dressType,
          conciergeOption,
          appointmentType: getApptBasedOnDress(),
        }],
      };
      mutate(input, { canProceed, onboardingProceed, newAppointmentProceed });
    } else {
      setProcessData(false);
    }
  };

  const valid = !!(dressType && conciergeOption && email && firstName && lastName && phoneNo && phoneTypeS && zipCode && preferredLang);

  useEffect(() => {
    const { head } = document;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://181302.tracking.hyros.com/v1/lst/universal-script?ph=9ce99df8788751883d56ec077d783be0e2385d3244728ba58b2543d3f3c3fb7b&tag=!tracking';
    head.appendChild(script);
  }, []);

  const smsOptInText = () => 'By checking this box, you are signing up to receive offers, promotions, and other brand information via text message. You can unsubscribe at any time.';

  const emailOptInText = () => 'By checking this box, you are signing up to receive offers, promotions, and other brand information via email. You can unsubscribe at any time.';

  return (
    <div>
      <div className="appointment-select-type">
        <WelcomeFlagShip />
        <div className="mobile-main-image">
          <img src={BookingStep1} alt="booking-image" />
        </div>
        <div className="text-container">
          <h2 className="fs-lg">Get Started</h2>
        </div>
        <div className="form-container">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <InputLabel htmlFor="email" className="form-label">Email *</InputLabel>
              <InputMui
                fullWidth
                value={email}
                name="email"
                id="email"
                onChange={mySetEmail}
                disabled={getDisabledStatusForField(ccEmail)}
                required="true"
                helperText={showHelperText(isEmailValid, 'Please enter a valid email address')}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <InputLabel htmlFor="firstName" className="form-label">First Name *</InputLabel>
              <InputMui
                fullWidth
                id="firstName"
                value={firstName}
                name="firstName"
                onChange={(e) => setFirstName((e.target.value).trim())}
                disabled={getDisabledStatusForField(ccFirstName)}
                required="true"
              />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <InputLabel htmlFor="lastName" className="form-label">Last Name *</InputLabel>
              <InputMui
                id="lastName"
                fullWidth
                value={lastName}
                name="lastName"
                onChange={(e) => setLastName((e.target.value).trim())}
                disabled={getDisabledStatusForField(ccLastName)}
                required="true"
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <InputLabel htmlFor="phoneNo" className="form-label">Phone *</InputLabel>
              <InputMask
                name="phoneNo"
                mask="+1 (999) 999-9999"
                value={phoneNo}
                onChange={(e) => setPhoneNo((e.target.value).trim())}
                disabled={getDisabledStatusForField(phoneNo)}
              >
                {() => (
                  <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    value={phoneNo}
                    name="phoneNo"
                    id="phoneNo"
                    disabled={getDisabledStatusForField(phoneNo)}
                    required="true"
                    helperText={showHelperText(isPhoneNoValid, 'Please enter a valid phone number')}
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs={12} lg={4}>
              <InputLabel htmlFor="phone_type_select" className="form-label">Type</InputLabel>
              <SelectMui
                id="phone_type_select"
                hasDefaultOption
                defaultOptionLabel="Please Select One"
                name="phoneType"
                value={phoneTypeS}
                onChange={(e) => setPhoneType(e.target.value)}
                options={phoneNumberTypes}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <InputLabel htmlFor="zipCode" className="form-label">Zipcode *</InputLabel>
              <InputMui
                fullWidth
                value={zipCode}
                name="zipCode"
                id="zipCode"
                onChange={(e) => setZipCode((e.target.value).trim())}
                disabled={getDisabledStatusForField(ccZip)}
              />
            </Grid>
            <Grid container direction="row" xs={12} lg={12} alignItems="center">
              <Grid item lg="auto" md="auto" xs="auto">
                <Checkbox
                  checked={allowSmsCheckbox}
                  onChange={(e) => setAllowSmsCheckbox((e.target.checked))}
                  id="smsCheckbox"
                />
              </Grid>
              <Grid item lg={10} md={10} xs={10}>
                <InputLabel htmlFor="smsCheckbox" style={{ marginBottom: 0 }} className="form-label opt-in-label">{smsOptInText()}</InputLabel>
              </Grid>
            </Grid>
            <Grid container direction="row" xs={12} lg={12} alignItems="center">
              <Grid item lg="auto" md="auto" xs="auto">
                <Checkbox
                  checked={allowEmailCheckbox}
                  onChange={(e) => setAllowEmailCheckbox((e.target.checked))}
                  id="emailCheckbox"
                />
              </Grid>
              <Grid item lg={10} md={10} xs={10}>
                <InputLabel htmlFor="emailCheckbox" style={{ marginBottom: 0 }} className="form-label opt-in-label">{emailOptInText()}</InputLabel>
              </Grid>
            </Grid>
            <Grid item xs={12} className="remove-select-legend">
              <InputLabel htmlFor="dress_type_select" className="form-label">Category</InputLabel>
              <DressTypeSelect
                id="dress_type_select"
                onChange={handleSelect('dressType')}
                value={dressType}
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel htmlFor="preferred_lang_select" className="form-label">Select a Preferred Language</InputLabel>
              <SelectMui
                id="preferred_lang_select"
                hasDefaultOption
                name="preferredLang"
                value={preferredLang}
                onChange={(e) => setPreferredLang(e.target.value)}
                options={preferredLangs}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                  // classes: { paper: menuClasses.menuPaper },
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <ContinueButton onClick={handleContinue} displayIn={valid} buttonClass="left-align primary-btn" loading={processData} />
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default AppointmentForm;
